import { useCustomer } from "@contexts/CustomerContext";
import {
  Box,
  Burger,
  Drawer,
  Group,
  NavLink,
  NullIcon,
  Stack,
  Text,
} from "@repo/ui/core";
import { useDisclosure } from "@repo/ui/hooks";
import {
  IconArchive,
  IconLayoutDashboard,
  IconMessageQuestion,
  IconPresentation,
} from "@repo/ui/icons";
import { Link, useLocation } from "react-router";

const NAV_ITEMS = [
  { label: "Overview", path: "", icon: IconLayoutDashboard },
  { label: "Slides", path: "slides", icon: IconPresentation },
  { label: "Parking Lot", path: "parking", icon: IconArchive },
  { label: "FAQ", path: "faq", icon: IconMessageQuestion },
];

export function OnsiteNav() {
  const customer = useCustomer();
  const location = useLocation();
  const [opened, { toggle, close }] = useDisclosure(false);
  const basePath = `/${customer.id}/onsite`;

  return (
    <>
      <Box
        component="nav"
        px="xl"
        py="sm"
        style={{
          borderBottom: "1px solid var(--mantine-color-dark-4)",
          background: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(12px)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <Group justify="space-between" align="center">
          <Group gap="lg">
            <Link to={basePath} style={{ textDecoration: "none" }}>
              <NullIcon w={30} h={23} />
            </Link>
          </Group>

          <Group gap="sm" visibleFrom="sm">
            {NAV_ITEMS.map((item) => {
              const fullPath = item.path
                ? `${basePath}/${item.path}`
                : basePath;
              const isActive =
                item.path === ""
                  ? location.pathname === basePath
                  : location.pathname.startsWith(fullPath);

              return (
                <Link
                  key={item.path}
                  to={fullPath}
                  style={{ textDecoration: "none" }}
                >
                  <Group
                    gap={6}
                    px="sm"
                    py={6}
                    style={{
                      borderRadius: "var(--mantine-radius-sm)",
                      background: isActive
                        ? "color-mix(in srgb, var(--customer-accent) 12%, transparent)"
                        : "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <item.icon
                      size={16}
                      style={{
                        color: isActive
                          ? "var(--customer-accent-light)"
                          : "var(--mantine-color-dimmed)",
                      }}
                    />
                    <Text
                      size="sm"
                      fw={isActive ? 600 : 400}
                      style={{
                        color: isActive
                          ? "var(--customer-accent-light)"
                          : "var(--mantine-color-dimmed)",
                      }}
                    >
                      {item.label}
                    </Text>
                  </Group>
                </Link>
              );
            })}
          </Group>

          <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="sm" />
        </Group>
      </Box>

      <Drawer
        opened={opened}
        onClose={close}
        size="xs"
        title={<Text fw={600}>{customer.shortName} Onsite</Text>}
      >
        <Stack gap={0}>
          {NAV_ITEMS.map((item) => {
            const fullPath = item.path ? `${basePath}/${item.path}` : basePath;
            return (
              <NavLink
                key={item.path}
                component={Link}
                to={fullPath}
                label={item.label}
                leftSection={<item.icon size={18} />}
                active={
                  item.path === ""
                    ? location.pathname === basePath
                    : location.pathname.startsWith(fullPath)
                }
                onClick={close}
              />
            );
          })}
        </Stack>
      </Drawer>
    </>
  );
}
